'use client';

import { useSearchParams } from 'next/navigation';

export function useUrlParams() {
  const searchParams = useSearchParams();
  const section = searchParams.get('section');
  const initialOpenSection: 'contact' | 'refunds' | 'terms' | 'privacy' | null =
    section === 'contact' || section === 'refunds' || section === 'terms' || section === 'privacy'
      ? section
      : null;

  return { initialOpenSection };
}
